export default __webpack_public_path__ + "static/media/EVENT210AARRAY.f08d231a.png";